// Boards: LangGlobe, LangJoinError, LangJoinNameTaken, LangJoinBlocked; in English LangEnGuest, LangEnJoinError,
// LangEnJoinNameTaken, LangEnJoinBlocked; the globe and its menu: LanguageMenu. The page sets the direction.
import React from 'react';
import { t } from '../../i18n';
import LanguageMenu from './LanguageMenu';
import { CodeField, GeneralError, Logo, MainButton, NicknameField, Wordmark, isBlank, onTap } from './parts';

export default function GuestHome({ code, onCode, nickname, onNickname, join, onHost }) {
  return (
    <main className="screen">
      <div className="body" style={{ gap: 18, paddingTop: 48 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, paddingBottom: 12 }}>
          <Logo width="112" height="96" />
          <div style={{ font: '400 52px/1 var(--display)', textAlign: 'center' }}><Wordmark accent="#ee5a4a" /></div>
        </div>

        <CodeField value={code} onChange={onCode} notFound={join.error === 'notFound'} blocked={join.blocked} />
        <NicknameField value={nickname} onChange={onNickname} taken={join.error === 'nameTaken'} />

        <div style={{ flex: 1 }}></div>
        <MainButton enabledClass="btn-primary" disabled={isBlank(nickname) || join.blocked} onClick={join.run}>{t('home.join')}</MainButton>
        {join.error === 'general' && <GeneralError />}
        <a className="btn btn-block" href="#signin" onClick={onTap(onHost)}>{t('home.host')}</a>
      </div>
      <LanguageMenu corner />
    </main>
  );
}
